import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColorOptions, HorizontalAlignmentOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
interface ISectionData {
    subtitle: string;
    subtitle_aligment: string;
    subtitle_color?: string;
    copy?: string;
    copy_aligment?: string;
    copy_color?: string;
}
interface IPageComponentPostTextSectiondData extends NICmsContentComponent.IData {
    sections: ISectionData[];
}
@ICmsComponent<PageComponentPostTextSectionComponent>({
    id: 'post-text-section',
    name: 'Post Text Section',
    tags: ['blog', 'post', 'text', 'section'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'sections',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Sections',
            itemName: 'Section',
            fields: [
                <NICmsContentField.IField>{
                    key: 'subtitle',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Subtitle',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    key: 'subtitle_aligment',
                    type: NICmsContentField.EFieldType.choice,
                    options: HorizontalAlignmentOptions,
                    default: 'left',
                    title: 'Subtitle Aligment',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    key: 'subtitle_color',
                    type: NICmsContentField.EFieldType.choice,
                    options: ColorOptions,
                    default: 'col-1',
                    title: 'Subtitle Color'
                },
                <NICmsContentField.IField>{
                    key: 'copy',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Copy'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'copy_aligment',
                    type: NICmsContentField.EFieldType.choice,
                    options: HorizontalAlignmentOptions,
                    default: 'left',
                    title: 'Copy Aligment'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'copy_color',
                    type: NICmsContentField.EFieldType.choice,
                    options: ColorOptions,
                    default: 'col-11',
                    title: 'Copy Color'
                }
            ],
            default: [
                {
                    subtitle_aligment: 'left',
                    subtitle_color: 'col-1',
                    copy_aligment: 'left',
                    copy_color: 'col-11',
                    copy: 'Tack rooms are often bursting with boots for every occasion, yet you may be unfamiliar with ice boots or unaware of all the options. So, what exactly are they and why would your horse or pony need them? <p>&nbsp;</p> Cold therapies have been used for centuries to help injuries and pain in humans and animals. The purpose of using cold is to break the cycle of inflammatory response before it causes cell damage. <p>&nbsp;</p> ‘Cold-hosing’ is a common practice to cool muscles, tendons and ligaments in the lower legs. But with a recommended application of up to 20 minutes, that’s a considerable drain on your time — and water. Thankfully there’s an easier and hands-free way; the ice boot. ',
                    subtitle: 'Everything you need to know about Ice Boots ...'
                },
                {
                    subtitle_aligment: 'left',
                    subtitle_color: 'col-1',
                    copy_aligment: 'left',
                    copy_color: 'col-11',
                    copy: 'All equines are athletes to various degrees, and not just the performance horses. Like humans, their legs can be vulnerable to injury from jumping, schooling or other intense exercises, causing small tears to tissues known as micro-trauma. It’s thought cold therapy can support them as well as more substantial tissue trauma by: <p>&nbsp;</p>  <li>Promoting tissue repair and growth </li> <li>Reducing inflammation, swelling and secondary tissue damage</li> <li>Reducing discomfort </li>',
                    subtitle: 'The issues with tissues'
                },
                {
                    subtitle_aligment: 'left',
                    subtitle_color: 'col-1',
                    copy_aligment: 'left',
                    copy_color: 'col-11',
                    copy: 'Cooling tissues constricts blood flow. This reduces the inflammatory response which limits swelling, pain and secondary damage in new micro traumas or injuries. When the cold source is removed, tissues experience renewed circulation. White blood cells rush to the area and this promotes the healing of old injuries.  <p>&nbsp;</p> It also aids instant comfort by creating a numbing effect and activating the production of endorphins – the natural pain-relieving hormones. ',
                    subtitle: 'How cold therapy works'
                }
            ]
        }
    ]
})
@Component({
    selector: 'page-component-post-text-section',
    templateUrl: './post-text-section.html',
    standalone: true,
    imports: [NgClass, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentPostTextSectionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentPostTextSectiondData;
}
